<template>
  <div class="wechat-login-wrapper">
    <p class="wechat-login-desc">
      <span class="label">首次扫码提示：</span>
      <span>① 关注{{
        platformConfig.alias === 'jxic' ? '公众号' : ' 精彩纵横云采购 公众号'
      }}</span>
      <i class="el-icon-arrow-right icon-arrow"></i>
      <span>② 绑定登录手机号</span>
    </p>
    <!-- 二维码图片 -->
    <el-image
      v-loading="loading"
      class="qr-image"
      :src="qrCodeUrl"
      @click.native="getWeChatQrCode"
    >
      <template slot="error">
        <div
          class="image-slot"
          style="width: 100%; display: flex; flex-direction: column; text-align: center;"
        >
          <i class="el-icon-refresh-right"></i>
          <p>点击重新获取二维码</p>
        </div>
      </template>
    </el-image>
    <div
      v-if="showSuccessCover"
      class="scan-success"
      :style="`top: ${platformConfig.alias === 'jxic' ? '60%' : '50%'}`"
    >
      <img src="../../../assets/images/common/scan-success.png" alt="" />
      <p>登录成功</p>
    </div>
  </div>
</template>

<script>
import {
  getWeChatQrCodeApi,
  weChatLoginByAccountApi,
  checkWeChatLoginApi
} from '@/api/user'

import { mapGetters } from 'vuex'

export default {
  name: 'WeChatLogin',

  props: {
    jumpPathByIdentity: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      // 二维码链接地址
      qrCodeUrl: '',
      // 凭证信息
      ticket: '',
      loading: false,
      timer: null,
      // 显示扫码成功
      showSuccessCover: false
    }
  },

  computed: {
    ...mapGetters('system', ['platformConfig'])
  },

  created() {
    this.getWeChatQrCode()
  },

  beforeDestroy() {
    clearInterval(this.timer)
    clearTimeout(this.timer)
    this.timer = null
  },

  methods: {
    // 获取微信登录二维码
    async getWeChatQrCode() {
      // 保证扫码成功遮罩不出现
      this.showSuccessCover = false
      this.loading = true
      try {
        const res = await getWeChatQrCodeApi()
        const data = res.data || {}
        this.qrCodeUrl = data?.url || ''
        this.ticket = data.ticket

        clearInterval(this.timer)
        this.timer = null
        this.timer = setInterval(() => {
          this.checkLogin().then(res => {
            if (res.data.login) {
              clearInterval(this.timer)
              this.weChatLogin()
            }
          })
        }, 1000)
      } catch (err) {
        if (err.data) {
          this.$message.error(err.data.message || '获取二维码失败')
        }
      } finally {
        this.loading = false
      }
    },

    // 检验是否登录
    checkLogin() {
      const requestParams = {
        ticket: this.ticket
      }
      return new Promise(resolve => {
        checkWeChatLoginApi({ ticket: requestParams.ticket })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            if (err.data) {
              this.$message.error(
                err.data.message || '扫码登录失败，请稍后重试'
              )
            }
          })
      })
    },

    // 微信登录
    async weChatLogin() {
      const requestData = {
        ticket: this.ticket
      }
      try {
        const res = await weChatLoginByAccountApi(requestData)
        this.showSuccessCover = res.success
        this.jumpPathByIdentity(res.data.ac)
      } catch (err) {
        if (err.data) {
          if (err.data.data.wechatNotBind) {
            this.showSuccessCover = true
            clearTimeout(this.timer)
            this.timer = null
            this.timer = setTimeout(() => {
              this.$router.push({
                name: 'Bind',
                query: {
                  ticket: this.ticket
                }
              })
            }, 1000)
          } else {
            this.$message.error(err.data.message || '扫码登录失败，请稍后重试')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1400px) {
  .wechat-login-wrapper .scan-success {
    zoom: 0.85;
  }
}

.wechat-login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;

  .wechat-login-desc {
    margin-top: 6px;
    margin-bottom: 6px;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    .label {
      font-weight: bold;
    }
    .icon-arrow {
      margin-left: 2px;
      margin-right: 2px;
    }
  }

  .qr-image {
    width: 177px;
    height: 177px;
    display: flex;
    align-items: center;
    justify-content: center;

    .image-slot {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      color: #909399;
      cursor: pointer;

      i {
        font-size: 2rem;
      }
    }
  }

  .scan-success {
    width: 215px;
    height: 215px;
    background-color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    @include text-bold;
    color: $white-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    padding-top: 25px;
    box-sizing: border-box;

    img {
      width: 60px;
      height: 60px;
    }
  }

  .scan-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.5;
  }
}
</style>
